import {SuspenseWhileLoading} from '@oc/components'
import React from 'react'

const CustomerV2 = React.lazy(async () => ({
    default: (await import('@oc/customer-v2/module')).CustomerV2Module
}))

export function CustomerV2Component() {
    return <SuspenseWhileLoading LazyComponent={CustomerV2} />
}

const Dashboard = React.lazy(async () => ({
    default: (await import('@oc/customer-v2/module')).DashboardModule
}))

export function DashboardV2Component() {
    return <SuspenseWhileLoading LazyComponent={Dashboard} />
}
